export enum LocationPhases {
  Signed = 'Signed',
  Launch = 'Launch',
  Open = 'Open',
  Closed = 'Closed',
  Draft = 'Draft',
  Greenlight = 'Greenlight',
  HardCommit = 'Hard Commit',
}
